<div class="dialog-container-main login-page">

  <section class=" login-page">
    <div class="container">
        <div class="login-content">
            <div class="flex-justify-center ">
                <div class="logo">
                    <img src="../../../../assets/images/svg/logo_green.svg" alt="" >
                </div>
            </div>
            <h4 class="login-heading">Login with One Time Password</h4>  
          
            <form [formGroup]="applicationForm"  autocomplete="off">
            <div class="login-mail">
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Email</mat-label>
                    <input  matInput  formControlName="username" 
                    type="text" autocomplete="off"
                    autocorrect="off"
                    autocapitalize="none"
                    spellcheck="false"  placeholder="Email address*">
                  </mat-form-field>
                  <p  *ngIf="otpTried>0" (click)="changeEmail()" class="change-email">Change Email</p>
                    

            </div>
            <div class="login-password"  *ngIf="otpTried>0" >
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Enter OTP</mat-label>                   
                    <input matInput formControlName="password"   placeholder="OTP*"
                [type]="hide ? 'password' : 'text'" />
              
                <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                  <mat-icon matSuffix class="material-icons-outlined email-icon-login">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
               
                   
                  </mat-form-field>

            </div>
            <!-- [disabled]="submitted"
              (click)="onSubmit()" -->
            <button mat-button class="login-submit" mat-flat-button
              cdkFocusInitial      *ngIf="otpTried==0"       
              (click)="sendOtp()" 
            >
              {{SendOTPButton}} <svg width="31" height="16" viewBox="0 0 31 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M30.7071 8.70711C31.0976 8.31658 31.0976 7.68342 30.7071 7.29289L24.3431 0.928932C23.9526 0.538408 23.3195 0.538408 22.9289 0.928932C22.5384 1.31946 22.5384 1.95262 22.9289 2.34315L28.5858 8L22.9289 13.6569C22.5384 14.0474 22.5384 14.6805 22.9289 15.0711C23.3195 15.4616 23.9526 15.4616 24.3431 15.0711L30.7071 8.70711ZM0 9H30V7H0V9Z" fill="white"/>
                </svg>
                </button>

                <button mat-button class="login-submit" mat-flat-button
                cdkFocusInitial            
                (click)="verifyOtp()" 
                *ngIf="otpTried>0" 
              >
                {{Verifybutton}} <svg width="31" height="16" viewBox="0 0 31 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M30.7071 8.70711C31.0976 8.31658 31.0976 7.68342 30.7071 7.29289L24.3431 0.928932C23.9526 0.538408 23.3195 0.538408 22.9289 0.928932C22.5384 1.31946 22.5384 1.95262 22.9289 2.34315L28.5858 8L22.9289 13.6569C22.5384 14.0474 22.5384 14.6805 22.9289 15.0711C23.3195 15.4616 23.9526 15.4616 24.3431 15.0711L30.7071 8.70711ZM0 9H30V7H0V9Z" fill="white"/>
                  </svg>
                  </button>
</form>
                <div class="register-user" *ngIf="otpTried>0 && otpTried<5">
                  <button [disabled]="resendButton"  [routerLink]="" (click)="sendOtp()" class="resend-btn margin-right1" >Resend OTP</button><p *ngIf="timer>0" class="margin0">in {{timer}} sec.</p>
                  

              </div>
                <div class="register-user margin-top2">
                  <a  [routerLink]="" (click)="backToLogin()" >Login with Password</a>
              </div>
                <div class="register-user margin-top2">
                    <a  [routerLink]="" (click)="onRegister()" >Join Cashel Family Office?</a>
                </div>
                <!-- <div class="forget-password margin-top2">
                    <a  href="javascript:void(0);" (click)="forgotPassword()" >Forgot your password?</a>
                </div> -->

        </div>
        
    </div>
</section>

</div>
